import { useEffect, useMemo } from 'react'
import { useStorePartsLazyQuery } from '../../../../../graphql'

export default function useAssociatedStorePart( storeId?: number, partId?: number ) {
	const [ fetchStoreParts, { data, loading } ] = useStorePartsLazyQuery()
	const storePart = useMemo( () => {
		if ( data?.storeParts?.length ) {
			return data.storeParts[ 0 ]
		}
		return undefined
	}, [ data?.storeParts ] )

	useEffect( () => {
		if ( storeId && partId ) {
			fetchStoreParts( { variables: { partIds: [ partId ], storeIds: [ storeId ] } } )
		}
	}, [ storeId, partId ] )

	return {
		loading,
		storePart,
	}
}
